import SectionHeading from "./SectionHeading";
import { highlights } from "@/mocks/movieContent";

export default function HighlightSection() {
  return (
    <section id="highlights" className="scroll-mt-20 bg-background-200/50 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <SectionHeading
          eyebrow="看点风格"
          title="看点与风格：它到底“好看”在哪里"
          description="除了剧情本身，这部影片在影像、声音和节奏上也有自己的处理方式。下面六点，是理解它气质的关键。"
          icon="ri-sparkling-line"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {highlights.map((item) => (
            <article
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 transition-colors hover:border-accent-300"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-800">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}